import React from 'react';
interface GuidelineSectionProps {
  id: string;
  title: string;
  children: React.ReactNode;
}
const GuidelineSection: React.FC<GuidelineSectionProps> = ({
  id,
  title,
  children
}) => {
  return <section id={id} className="py-6" data-id="element-60">
      <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-61">{title}</h2>
      <div className="prose prose-blue max-w-none" data-id="element-62">{children}</div>
    </section>;
};
export default GuidelineSection;